<template>
    <div id="app" class="page-wrapper">
        <div class="search-List">
            <div class="search-message">
                <div class="search-message-title">搜索结果</div>
                <div class="search-message-detail clearfix">
                    <span class="search-keyword">“{{keyword}}”相关的搜索结果</span>
                    <!-- <span class="search-number">共{{totalCount}}条搜索结果</span> -->
                </div>
            </div>
            <div v-show="noData" class="no-search-result">
                <p>无搜索结果，换个关键词试试吧~</p>
                <img src="./../assets/img/search_none.png" alt="">
            </div>
            <NewsList :list="list"/>
            <div v-show="!noData && (isLoading || lastDataId == -1)" class="loadMore">
                {{lastDataId == -1 ? '已经到底了' : '加载更多...'}}
            </div>
        </div>
    </div>
</template>
<script>
import NewsList from '@/components/NewsList'
import { mapState, mapMutations } from 'vuex'
export default {
    name: 'Search',
    data() {
        return {
            list: [],
            isLoading: false,
            keyword: '',
            page: 1,
            pageSize: 50,
            lastDataId: null,
            noData: false
        }
    },
    watch: {
        $route(val) {
            if(val.query.keyword != this.keyword) {
                this.setInit();
                this.keyword = this.$route.query.keyword || '';
                this.getData(true);
            }
        }
    },
    components: {
        NewsList
    },
    created() {
        // 获取列表数据
        document.title = "四川互联网举报辟谣平台";
        this.keyword = this.$route.query.keyword || '';
        this.getData(true);
    },
    mounted() {
        
    },
    methods: {
        ...mapMutations(['freshSearch', 'setLoadingShow']),
        getData(flag) {
            if(this.noData || this.isLoading || this.lastDataId == -1) {
                return;
            }
            this.isLoading = true
            this.$axios.post(
                this.$ApiInfo.getSearchResult,
                {
                    page: this.page,
                    pageSize: this.pageSize,
                    lastDataId: this.lastDataId,
                    keyword: this.keyword
                }
            ).then(data => {
                if(this.page == 1 && !this.noData) {
                    if(!data || !data.list || !data.list.length) {
                        this.noData = true;
                        this.setLoading();
                        this.freshSearch(false);
                        return;
                    }
                }
                if(data && data.list && data.list.length) {
                    this.list.push(...data.list);
                }
                this.lastDataId = data.lastDataId;
                this.page++;
                this.isLoading = false;
                this.setLoading();
                this.freshSearch(false);
            })
        },
        setInit() {
            this.list = [];
            this.isLoading = false;
            this.keyword = '';
            this.page = 1;
            this.pageSize = 50;
            this.lastDataId = null;
            this.noData = false;
        },
        setLoading() {
            this.setLoadingShow(false);
            this.$nextTick(()=> {
                let footerHeight = 0;
                document.querySelector('.footer-wrapper') && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 100)
                this.$Common.loadScroll(footerHeight, this.getData);
            })
        }
    },
    watch: {
        freshSearchFlag(val) {
            if(val) {
                this.setInit();
                this.keyword = this.$route.query.keyword || '';
                this.getData();
            }
        }
    },
    computed: {
        ...mapState(['freshSearchFlag']),
    }
}
</script>
<style lang="less" scoped>
.search-message {
    margin-top: 0.625rem;
    margin-bottom: 1.5rem;
    color: #fff;
    .search-message-title {
        font-size: 1.125rem;
        line-height: 1.5625rem;
        border-bottom: 0.125rem solid #fff;
        padding-bottom: 0.25rem;
    }
    .search-message-detail {
        font-size: 1.375rem;
        line-height: 1.875rem;
        margin-top: 1rem;
        .search-keyword {
            font-size: 1.375rem;
            float: left;
        }
        .search-number {
            font-size: 1.125rem;
            float: right;
        }
    }
}
.no-search-result {
    color: #fff;
    font-size: 1.5rem;
    text-align: center;
    margin-top: 1.875rem;
    margin-bottom: 5.625rem;
    img {
        width: 4.75rem;
        height: 5rem;
        margin-top: 2.75rem;
    }
}
</style>